module.exports = __webpack_public_path__ + "img/2.6_Our-Logo_artwork-image.d4e352907ef9b4d606d3978ccd5b15a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Our-Logo_artwork-image.png
// module id = 793
// module chunks = 0